import {content as assetsContent} from './assets';
import {content as campaignsContent} from './campaigns';
import {content as codeComponentsContent} from './code-components';
import {content as componentsContent} from './components';
import {content as tokensContent} from './tokens';
import {content as designModesContent} from './design-modes';
import {content as localization} from './localization';
import {content as branches} from './branches';
import {content as pagesContent} from './pages';
import {content as optimizationContent} from './optimization';
import {content as presenceContent} from './presence';
import {content as customCodePreviewContent} from './customCodePreview';
import {content as siteSnapshotsContent} from './siteSnapshots';
import {content as interactionsContent} from './interactions';
import {content as reviewsContent} from './reviews';
import {content as enterpriseBillingContent} from './enterpriseBilling';
import {content as instructionsContent} from './instructions';

export const content = {
  ...assetsContent,
  ...campaignsContent,
  ...codeComponentsContent,
  ...componentsContent,
  ...tokensContent,
  ...designModesContent,
  ...localization,
  ...branches,
  ...pagesContent,
  ...optimizationContent,
  ...presenceContent,
  ...customCodePreviewContent,
  ...siteSnapshotsContent,
  ...interactionsContent,
  ...reviewsContent,
  ...enterpriseBillingContent,
  ...instructionsContent,
} as const;
